import { ComponentType } from "preact";
import { Route } from "./route";

export class Router {
  private readonly parsedRoutes: ParsedRoute[];

  constructor(private readonly routes: Route[]) {
    this.parsedRoutes = routes.map((r) => new ParsedRoute(r));
  }

  match(path: string): RoutingResult | null {
    let i = 0;
    for (const parsedRoute of this.parsedRoutes) {
      const match = parsedRoute.match(path);
      if (match) {
        const { route } = parsedRoute;
        const getComponentFn = route.getComponent;
        return {
          index: i,
          params: match.params,
          componentFn: getComponentFn,
          modules: route.sourceModules,
        };
      }

      i++;
    }

    return null;
  }
}

export interface RoutingResult {
  index: number;
  params?: { [key: string]: unknown };
  componentFn: () => Promise<ComponentType>;
  modules: string[];
}

interface ParsedRouteMatch {
  matched: true;
  params?: { [key: string]: unknown };
}

class ParsedRoute {
  private readonly paramNames: string[];
  private readonly matchRegExp: RegExp;

  constructor(readonly route: Route) {
    let re = "^";
    let inConstraint = false;
    let currentConstraint = "";
    let paramNames: string[] = [];

    for (const c of route.path) {
      if (c === "{") inConstraint = true;
      else if (c === "}" && inConstraint) {
        // TODO: support constraint types (e.g. foo:num, bar:*)
        inConstraint = false;
        paramNames.push(currentConstraint);
        currentConstraint = "";

        re += "([^/]*)";
      } else if (inConstraint) {
        currentConstraint += c;
      } else {
        // Add as-is to RE (TODO: escape RE special chars)
        re += c;
      }
    }

    re += "$";

    this.matchRegExp = new RegExp(re);
    this.paramNames = paramNames;
  }

  match(path: string): ParsedRouteMatch | null {
    const reMatch = path.match(this.matchRegExp);
    if (!reMatch) return null;

    const params: any = {};
    for (let i = 0; i < reMatch.length - 1; i++) {
      const name = this.paramNames[i];
      const value = reMatch[i + 1];
      params[name] = value;
    }

    return {
      matched: true,
      params,
    };
  }
}
